export const CURRENT_CONFIG = {
  // license
  appId: '158962', // You need to go to the development website to apply.
  appKey: '0015d848a9d0fc77ce1dd15c51810c8', // You need to go to the development website to apply.
  appLicense: 'qzhMdHD4UeLngDv8lef9lPzXWpyVAi8AMlB1IWc1W+UmHGUC7QiJ3+ecp8xa+42YlEwD48xFgEaN+HjQTWAQb0XaXQb5RljvJSGIDkSjJeeyzf5KznE+f8erHnYFJtj7d9I85BR8nEeVKVljeUhKcUMF4inmyu1x122i2SDR5LI=', // You need to go to the development website to apply.

  // http
  // baseURL: 'http://127.0.0.1:6789/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  // websocketURL: 'ws://127.0.0.1:6789/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'
  baseURL: 'http://111.31.95.226:8888/api/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'ws://111.31.95.226:8888/wss/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  liveType: 1, // 1 rtmp / 3 gb28181
  rtmpURL: 'rtmp://111.31.95.226:1935/live/', // Example: 'rtmp://123.150.46.202:32006/live/' rtmp://wx.sl.zltt.cn:11935/live/
  rtmpSign: '?sign=24bfc61b7440d8211c33be0c0a6eff21', // Example: 'rtmp://123.150.46.202:32006/live/' rtmp://wx.sl.zltt.cn:11935/live/
  rtcUrl: 'http://111.31.95.226:8888/webrtc/index/api/webrtc?app=',
  recordUrl: 'http://111.31.95.226:8888/minio',
  qrcodeUrl: 'http://111.31.95.226:8888/share?stream=',
  imageMediaParam: '1920x1080/origin/', // This url must end with "/".
  imagePreviewParam: '250x200/origin/', // This url must end with "/".
  imageEventPreviewParam: '360x270/origin/', // 预警事件缩略图
  imageIconParam: '40x40/origin/', // This url must end with "/".
  imageURL: 'http://111.31.95.226:8888/preview/unsafe/', // This url must end with "/". 123.150.46.202:32003
  imageResultURL: 'https://cloud.aizerone.com/preview/rx/', // This url must end with "/".
  imageMinioURL: 'http://111.31.95.226:8888/minio/origin/', // This url must end with "/".
  terraMinioURL: 'http://111.31.95.226:8888/minio/map/', // This url must end with "/".
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: '111.31.95.226',
  gbServerPort: '5060',
  gbServerId: '34020000002000000001',
  gbAgentId: '34020000002000000001',
  gbPassword: 'Admin@2025',
  gbAgentPort: '5060',
  gbAgentChannel: '34020000002000000001',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // AI
  enableAI: 0, // 0 1
  // 是否显示管控平台推送按钮
  enableGuanKong: 1, // 0 1
  // ai output
  minioPath: '/mnt/data/minio_data/origin/',
  // Weather
  enableWeather: 1, // 0 1
  // LocalMap
  enableLocalMap: 0, // 0 1
  localMapType: 'WGS84', // WGS84 GCJ02
  localMapUrlCia: 'http://111.31.95.226:8888/minio/map/tmap/tianjin_biaozhu-z0-18.cHybNXgNg/{z}/{x}/{y}.png', // 标注图层
  localMapUrlImg: 'http://111.31.95.226:8888/minio/map/tmap/tianjin_yingxiang-z0-18.eS2dvugNR/{z}/{x}/{y}.png', // 影像图层
  localTerrainUrl: 'http://111.31.95.226:8888/minio/map/elevation/terrain/global_ellipsoid/', // 高程图层
  // amap
  // You can apply on the AMap website.
  amapKey: 'e88a8a84a8907604a139e45cb931f686',
}
